import { render, staticRenderFns } from "./FacultiesList.vue?vue&type=template&id=4789ec0e&scoped=true&"
import script from "./FacultiesList.vue?vue&type=script&lang=js&"
export * from "./FacultiesList.vue?vue&type=script&lang=js&"
import style0 from "./FacultiesList.vue?vue&type=style&index=0&id=4789ec0e&scoped=true&lang=scss&"
import style1 from "./FacultiesList.vue?vue&type=style&index=1&id=4789ec0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789ec0e",
  null
  
)

export default component.exports